/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const VerticalCharging20SolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v.5h-4V2Zm5 3H9a1 1 0 0 0-1 1v11.8h4.842c-.502 1.003.222 2.225 1.383 2.225h.8l-.505 2.526c-.031.157-.04.307-.03.449H9a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v5.42a1.485 1.485 0 0 0-1.53.695l-.47.734V6a1 1 0 0 0-1-1Zm2.892 7.682a.285.285 0 0 0-.37.107l-3.543 5.537a.292.292 0 0 0 .246.449h2.325l-.804 4.021c-.064.317.357.486.531.215l.29-.452 1.413-2.208 1.84-2.877a.292.292 0 0 0-.245-.449H17.25l.75-3.75.054-.271a.282.282 0 0 0-.054-.238.3.3 0 0 0-.108-.084Z" /></svg>);
const VerticalCharging20Solid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={VerticalCharging20SolidBase} {...rest} ref={ref} />);
export default VerticalCharging20Solid;